import {
  createSlice,
  createAsyncThunk
} from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
  loading: false,
  data: [],
  error: ''
};

export const fetch = createAsyncThunk('simplePicking/fetch',
  async ({warehouseId, accessToken}) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + '/simple-picking', {
      headers: {
        Authorization: "Bearer " + accessToken
      },
      params: {
        warehouse_id: warehouseId
      }
    });

    return response.data;
  })

const simplePickingSlice = createSlice({
  name: 'simplePicking',
  initialState,
  reducers: {},
  extraReducers: {
    [fetch.pending]: (state, action) => {
      state.loading = true
      state.error = ''
      state.data = []
    },
    [fetch.fulfilled]: (state, action) => {
      state.loading = false
      state.data = action.payload
    },
    [fetch.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },
  },
})

export default simplePickingSlice.reducer

export const selectAll = (state) => {
  return state.simplePickingList
}
